module.exports = __webpack_public_path__ + "static/img/ikona_cw3-ON.bc12516b.png";